import React from "react";
import ChrMetricTitle from "../../Basic/Metric/ChrMetricTitle";
import ChrMetricValue from "../../Basic/Metric/ChrMetricValue";
import ChrMetricContainer from "../../Basic/Metric/ChrMetricContainer";
import ChrSubMetric from "./ChrSubMetric";
import ChrComparison from "../../../../specific/Reports/templates/ChrComparison";
import ChrAlert from "../../Basic/Metric/ChrAlert";

/*
props = {
  name: <string | component>,
  helpText: <string>,
  data: {
    value: <string | component>,
  },
  subMetrics = [<props of ChrSubMetric>,...],
  url: <string>,
  badges: [{ text: <string>, type: <bootstrap badge type. Refer ChrBadge> },...]
}
*/

const ChrMetric = (props) => {
  const { helpText, badges, name, hoverContent, className, data: { value, previousPeriod, alert = {} }, subMetrics, url, marker = {}, subMetricContainerClass = '' } = props;
  const SubMetricComponent = props.subMetricComponent || ChrSubMetric;
  return (
    <ChrMetricContainer className={ className }>
      <ChrMetricTitle helpText={ helpText } badges={ badges } hoverContent={ hoverContent || name }>
        { marker.show && <i className={`fa fa-square pr-2 ${marker.className}`} /> }
        { name }
      </ChrMetricTitle>
      <div className="d-flex flex-gap-5 align-items-center">
        <ChrMetricValue url={ url } eventDetails={ props.eventDetails }>
          { value }
        </ChrMetricValue>
        <ChrAlert {...alert} containerLocator="#cjs-management-report-v2" className="pr-2"/>
        { previousPeriod && <ChrComparison
          changeSentiment={ previousPeriod.insights.sentiment }
          changeValue={ previousPeriod.insights.changeValue }
          changeDirection={ previousPeriod.insights.direction }
          periodOne={ { dateRangeStr: previousPeriod.comparedAgainstPeriod.dateRangeStr, presetStr: previousPeriod.comparedAgainstPeriod.presetStr, value: value } }
          periodTwo={ { dateRangeStr: previousPeriod.timePeriod.dateRangeStr, presetStr: previousPeriod.timePeriod.presetStr, value: previousPeriod.value } }
        /> }
      </div>
      { subMetrics &&
        <div className={`d-flex flex-row ${ subMetricContainerClass }`}>
          {
            subMetrics.map((metric, index) => <SubMetricComponent key={ index } { ...metric } />)
          }
        </div>
      }
    </ChrMetricContainer>
  );
};

export default ChrMetric;
